import { Formatter } from 'dg-web-shared/lib/Date.ts';
import { DateTime } from 'luxon';
import { css } from '@emotion/css';

export function ValidFromDisplay({ validFrom }: { validFrom: string }) {
    return (
        <div className={css({ whiteSpace: 'nowrap' })}>
            {formatDateAndTime(validFrom)}
        </div>
    );
}

export function ValidFromValidToDisplay({
    validFrom,
    validTo,
}: {
    validFrom: string;
    validTo: string;
}) {
    const from = formatDateAndTime(validFrom);
    const to = formatDateAndTimeIfSameDay(validTo, validFrom);

    const display = `${from} / ${to}`;

    return <div className={css({ whiteSpace: 'nowrap' })}>{display}</div>;
}

/**
 * Show date only if validTo is on a different day than validFrom.
 * Always show time.
 */
function formatDateAndTimeIfSameDay(validTo: string, validFrom: string) {
    if (isSameDay(validFrom, validTo)) {
        return Formatter.hourMinute(DateTime.fromISO(validTo));
    } else {
        return formatDateAndTime(validTo);
    }
}

function formatDateAndTime(date: string) {
    return Formatter.dayMonthYearHourMinute(DateTime.fromISO(date));
}

function isSameDay(validFrom: string, validTo: string) {
    return (
        DateTime.fromISO(validFrom).toISODate() ===
        DateTime.fromISO(validTo).toISODate()
    );
}
